<template>
  <div class="flex">
    <div class="flex flex-col sm:flex-row">
      <div class="w-full md:w-1/3 space-y-5 px-10">
        <img
          class="rounded w-32 h-32 md:w-48 md:h-48 object-cover"
          id="profile-picture"
          :src="data?.headless_content.portrait"
        />
        <div>
          <h1>{{ data?.headless_content.full_name }}</h1>
          <h3>{{ data?.headless_content.role }}</h3>
        </div>
        <div>
          <a
            v-if="data?.headless_content.personal_website"
            class="tx-link"
            target="_blank"
            :href="data?.headless_content.personal_website"
            >Website</a
          >
        </div>
        <div class="flex space-x-2">
          <a
            v-if="data?.headless_content.facebook_url"
            id="profile-facebook"
            class="tx-link flex"
            target="_blank"
            :href="data?.headless_content.facebook_url"
          >
            <img class="profile-social-icon" src="/img/icons/social-facebook-icon.svg" />
          </a>
          <a
            v-if="data?.headless_content.instagram_url"
            id="profile-instagram"
            class="tx-link flex"
            target="_blank"
            :href="data?.headless_content.instagram_url"
          >
            <img class="profile-social-icon" src="/img/icons/social-instagram-icon.svg" />
          </a>
          <a
            v-if="data?.headless_content.linkedin_url"
            id="profile-linkedin"
            class="tx-link flex"
            target="_blank"
            :href="data?.headless_content.linkedin_url"
          >
            <img class="profile-social-icon" src="/img/icons/social-linkedin-icon.svg" />
          </a>
          <a
            v-if="data?.headless_content.twitter_url"
            id="profile-twitter"
            class="tx-link flex"
            target="_blank"
            :href="data?.headless_content.twitter_url"
          >
            <img class="profile-social-icon" src="/img/icons/social-x-icon.svg" />
          </a>
          <a
            v-if="data?.headless_content.youtube_url"
            id="profile-youtube"
            class="tx-link flex"
            target="_blank"
            :href="data?.headless_content.youtube_url"
          >
            <img class="profile-social-icon" src="/img/icons/social-youtube-icon.svg" />
          </a>
        </div>
      </div>
      <div class="sm:overflow-y-auto w-full md:w-2/3 px-10 mt-5 md:mt-0 space-y-5">
        <div v-if="data?.headless_content.bio">
          <h2>{{ $t('Bio') }}</h2>
          <p><div v-html="data?.headless_content.bio"></div></p>
        </div>
        <div v-if="data?.headless_content.travel_background" id="profile-background">
          <h2>{{ $t('Travel background') }}</h2>
          <p><div v-html="data?.headless_content.travel_background"></div></p>
        </div>
        <div v-if="data?.headless_content.best_travel_experiences">
          <h2>
            {{ $t('Best travel experiences') }}
          </h2>
          <p><div v-html="data?.headless_content.best_travel_experiences"></div></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { handleApiResponse } from '~/server/utils/utils';
const route = useRoute();

const { t, locale } = useI18n();

const { data, error } = await handleApiResponse(`/api/about`, {
  params: {
    type: 'member',
    lang: locale.value.split('-')[0],
    member_name: route.params.member_name,
  },
});

const pageTitle = computed(() => {
  return data?.value?.headless_content.full_name + '-' + data?.value?.headless_content.role + ' | TourScanner';
});

const pageDescription = computed(() => {
  return data?.value?.headless_content.full_name + ' | TourScanner';
});

useHead({
  title: pageTitle,
  description: pageDescription,
  meta: [
    { name: 'title', content: pageTitle },
    { name: 'description', content: pageDescription },
    { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
  ],
});

const rule = useRobotsRule();
if (rule) {
  rule.value = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
}

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
});
</script>

<style scoped>
.profile-social-icon {
  @apply w-6 h-6;
}
</style>
